module.exports = __webpack_public_path__ + "img/jameson-4-text.d9de9a51.png";